export const API_V2_MEDIA_TYPE = 'application/vnd.bgx.v2+json';

export const toApiResponse = (payload, status = 200) => {
  const body = payload && typeof payload === 'object' ? payload : { data: payload };
  const error = body.error || null;
  const isEcSuccess = body.EC === undefined || Number(body.EC) === 1;

  return {
    ...body,
    EC: body.EC !== undefined ? body.EC : (error ? -1 : 1),
    EM: body.EM || body.message || error?.message || '',
    DT: body.DT !== undefined ? body.DT : body.data,
    data: body.data ?? body.DT,
    message: body.message || body.EM || error?.message || '',
    error,
    ok: !error && status >= 200 && status < 400 && isEcSuccess,
    status,
  };
};
